import { Component, OnInit } from '@angular/core';
import { DashboardContentieuxService } from '../../core/service/suiviPortefeuille/dashboard-contentieux.service';
import { first } from "rxjs/operators";
import { ChartViewDTO } from '../../core/model/chart_view/chart-view-dto';
import * as Highcharts from "highcharts";

@Component({
  selector: "app-contentieux",
  templateUrl: "./contentieux.component.html",
  styleUrls: ["./contentieux.component.scss"]
})
export class ContentieuxComponent implements OnInit {
  highcharts = Highcharts;

  nombreByPeriode: ChartViewDTO;
  chartOptionsSuiviByPeriode: any;

  quantiteByPeriode: ChartViewDTO;
  chartOptionsQuantiteByPeriode: any;

  evolutionNombreByPeriode: ChartViewDTO;
  chartOptionsSuivievolutionNombreByPeriode: any;
  constructor(
    private _dashboardContentieuxService: DashboardContentieuxService
  ) {}

  ngOnInit() {
    this.nombreDossierContentieux();
    this.quantiteDossierContentieux();
    this.nombreDossierContentieuxProvision();
  }

  nombreDossierContentieux() {
    this._dashboardContentieuxService
      .nombreDossierContentieux()
      .pipe(first())
      .subscribe(
        response => {
          this.nombreByPeriode = response;

          this.chartOptionsSuiviByPeriode = {
            chart: {
              type: "spline"
            },
            title: {
              text:
                "Evolution des déclassements de dossier sur les 12 derniers mois"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.nombreByPeriode.categories
            },
            yAxis: {
              title: {
                text: "Qté"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            series: this.nombreByPeriode.series
          };
        },
        error => {
          console.log(error);
        }
      );
  }


  nombreDossierContentieuxProvision() {
    this._dashboardContentieuxService
      .nombreDossierContentieuxProvions()
      .pipe(first())
      .subscribe(
        response => {
          this.evolutionNombreByPeriode = response;

          this.chartOptionsSuivievolutionNombreByPeriode = {
            chart: {
              type: "spline"
            },
            title: {
              text: "Evolution des provisions sur les 12 derniers mois"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.evolutionNombreByPeriode.categories
            },
            yAxis: {
              title: {
                text: "Montant"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            series: this.evolutionNombreByPeriode.series
          };
        },
        error => {
          console.log(error);
        }
      );
  }


  quantiteDossierContentieux() {
    this._dashboardContentieuxService
      .quantiteDossierContentieux()
      .pipe(first())
      .subscribe(
        response => {
          this.quantiteByPeriode = response;

          this.chartOptionsQuantiteByPeriode = {
            chart: {
              type: "column" // Changer le type en "column"
            },
            title: {
              text: "Quantité de dossier sur les 12 derniers mois"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.quantiteByPeriode.categories
            },
            yAxis: {
              title: {
                text: "Qté"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            plotOptions: {
              column: {
                stacking: "normal", // Ajouter cette ligne pour empiler les colonnes
                dataLabels: {
                  enabled: true
                }
              }
            },

            series: this.quantiteByPeriode.series
          };
        },
        error => {
          console.log(error);
        }
      );
  }
}
